import Show from '../views/floors/show'

export default [
    {
        path: '/admin/floor/:id',
        name: 'floor-show',
        component: Show,
    }
]
